import style from '../PaymentStatusScreen.module.css';

interface WidgetProps {
    widget : any
}
const PaymentSteps = ({widget} : WidgetProps) => {
    if(widget && widget.html == ''){
        return <></>
    }
    return <div className="card border-0 shadow-sm mt-3">
        <div className="card-body ">
            <div dangerouslySetInnerHTML={{ __html: widget.html }} />
        </div>
    </div>
}

export default PaymentSteps;